var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7698 0.412842H9.23138L6.46222 3.27515H0.923828V17.5871H23.0777V3.27515H17.539L14.7698 0.412842ZM12.0013 14.7246C14.2954 14.7246 16.1552 12.8023 16.1552 10.431C16.1552 8.05977 14.2954 6.13747 12.0013 6.13747C9.7072 6.13747 7.84746 8.05977 7.84746 10.431C7.84746 12.8023 9.7072 14.7246 12.0013 14.7246ZM14.7703 10.4313C14.7703 12.0121 13.5304 13.2936 12.001 13.2936C10.4716 13.2936 9.2318 12.0121 9.2318 10.4313C9.2318 8.85041 10.4716 7.56888 12.001 7.56888C13.5304 7.56888 14.7703 8.85041 14.7703 10.4313Z",
    fill: "var(--klothed-bgColor)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSelected);
export default __webpack_public_path__ + "static/media/imageSelected.1c02849d66d3f77d52cb17c02bf3b22d.svg";
export { ForwardRef as ReactComponent };